import { Injectable } from '@angular/core';

import { ActivateLicenseRequest } from '@reach/interfaces/plans/plans.requests';
import {
	ActivateLicenseResponse,
	GetCurrentPlanResponse,
} from '@reach/interfaces/plans/plans.responses';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class PlansApiService extends BaseApiService {
	protected commonPath = ['plans'];

	public async activateLicense(licenseKey: string): Promise<ActivateLicenseResponse> {
		const body: ActivateLicenseRequest = { licenseKey };
		return await this.http.post<ActivateLicenseResponse>(this.url('activate-license'), body);
	}

	public async getCurrentPlan(): Promise<GetCurrentPlanResponse> {
		return await this.http.get<GetCurrentPlanResponse>(this.url('current'));
	}
}
